import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {AppState} from '../../../../store/appState';
import {makeGetAnswerFolderPathNames} from '../../../../store/data/answerFolders/answerFoldersSelectors';
import {
  AnswerFolderSearchResultsDropdownItem,
  AnswerFolderSearchResultsDropdownItemProps,
} from './answerFolderSearchResultsDropdownItem';

type AnswerFolderSearchResultsDropdownItemContainerProps = Omit<
  AnswerFolderSearchResultsDropdownItemProps,
  'fullFolderPathNames'
>;

function getFolderId(_state: AppState, props: AnswerFolderSearchResultsDropdownItemContainerProps) {
  return props.folder;
}

// TODO: fullFolderPathNames should actually be included with the AnswerFolderModel object itself in the future, and
//       this entire container can be removed.
const mapStateToProps = makeMapStateToProps<AnswerFolderSearchResultsDropdownItemContainerProps>()(() => ({
  fullFolderPathNames: makeGetAnswerFolderPathNames(getFolderId),
}));

export const AnswerFolderSearchResultsDropdownItemContainer = connect(mapStateToProps)(
  AnswerFolderSearchResultsDropdownItem,
);
